module.exports = __webpack_public_path__ + "img/download_qr_ilifestyle.bb948db1.png";